import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';
import { injectIntl } from 'react-intl';

import { showModal } from '../../../actions';
import { showConfirmationModal } from '../../../actions/App';
import { fetchFileStatuses } from '../../../actions/Files';

import { APIdeleteFileStatus } from '../../../api/Files';
import { APIupdateSettings } from '../../../api/Settings';

import { addFlashMessage } from '../../../helpers/FlashMessages';
import EmptyTableCell from '../../EmptyTableCell';

class AdminFileStatusesListItem extends PureComponent {
  constructor(props) {
    super(props);

    this.handleEdit = this.handleEdit.bind(this);
    this.handleSwitchDefault = this.handleSwitchDefault.bind(this);
  }

  handleEdit() {
    const {
      status,
      openStatusEditModal,
      updateStatusOnList,
    } = this.props;

    openStatusEditModal({
      className: 'modal-edit-status',
      backdrop: true,
      status,
      afterCreateStatus: updateStatusOnList,
    });
  }

  handleSwitchDefault() {
    const {
      status,
      setDefaultStatus,
    } = this.props;

    if (status.default) {
      setDefaultStatus(null);
    } else {
      setDefaultStatus(status.id);
    }
  }

  render() {
    const {
      intl,
      status,
      handleDeleteStatus,
      deleteStatusFromList,
    } = this.props;

    const styles = {
      backgroundColor: status.color,
    };

    return (
      <tr>
        <th scope="row" className="status-name">
          <a
            href="#edit"
            onClick={this.handleEdit}
          >
            <i className="file-status" style={styles} />
            {status.name}
          </a>
        </th>
        <td className="status-files">
          {status.files}
        </td>
        <td className="status-default">
          {status.default ? (
            <i className="far fa-check" />
          ) : <EmptyTableCell />}
        </td>
        <td className="status-action">
          {status.action === 'disable_download' && intl.formatMessage({ defaultMessage: 'Disable downloading' })}
          {status.action === 'watermark' && intl.formatMessage({ defaultMessage: 'Add watermark' })}
          {!status.action && <EmptyTableCell />}
        </td>
        <td className="action-more">
          <UncontrolledDropdown>
            <DropdownToggle nav className="options">
              <i className="far fa-ellipsis-h" />
            </DropdownToggle>
            <DropdownMenu right container="body" className="list-item-actions-list">
              <DropdownItem
                onClick={this.handleSwitchDefault}
              >
                {status.default ? (
                  <>
                    <i className="fas fa-minus" />
                    {intl.formatMessage({ defaultMessage: 'Unset as default' })}
                  </>
                ) : (
                  <>
                    <i className="fas fa-check" />
                    {intl.formatMessage({ defaultMessage: 'Set as default' })}
                  </>
                )}
              </DropdownItem>
              <DropdownItem
                onClick={this.handleEdit}
              >
                <i className="fas fa-pencil" />
                {intl.formatMessage({ defaultMessage: 'Edit' })}
              </DropdownItem>
              <DropdownItem divider />
              <DropdownItem
                onClick={(e) => {
                  e.preventDefault();
                  handleDeleteStatus(status, deleteStatusFromList);
                }}
              >
                <i className="fas fa-trash" />
                {intl.formatMessage({ defaultMessage: 'Delete' })}
              </DropdownItem>
            </DropdownMenu>
          </UncontrolledDropdown>
        </td>
      </tr>
    );
  }
}

const mapDispatchToProps = (dispatch, props) => ({
  openStatusEditModal: (params) => {
    dispatch(showModal('FileStatusEditModal', params));
  },
  setDefaultStatus: (statusId) => {
    const { intl } = props;
    APIupdateSettings({ default_file_status: statusId }).then(() => {
      dispatch(fetchFileStatuses());
      addFlashMessage({
        type: 'success',
        text: intl.formatMessage({ defaultMessage: 'Your changes have been saved' }),
      });
    });
  },
  handleDeleteStatus: (status, callback) => {
    const { intl } = props;
    const modalParams = {
      title: intl.formatMessage({ defaultMessage: 'Are you sure?' }),
      text: intl.formatMessage({ defaultMessage: 'Are you sure you want to delete this file status? Doing this will not delete the files tagged with the status, but the status will be permanently removed.' }),
      onConfirm: () => (
        APIdeleteFileStatus(status.id).then(() => {
          dispatch(fetchFileStatuses());
          callback(status);
        })
      ),
    };
    dispatch(showConfirmationModal(modalParams));
  },
});

AdminFileStatusesListItem.propTypes = {
  intl: PropTypes.object.isRequired,
  openStatusEditModal: PropTypes.func.isRequired,
  setDefaultStatus: PropTypes.func.isRequired,
  handleDeleteStatus: PropTypes.func.isRequired,
  updateStatusOnList: PropTypes.func.isRequired,
  deleteStatusFromList: PropTypes.func.isRequired,
  status: PropTypes.object.isRequired,
};

export default withRouter(injectIntl(connect(null, mapDispatchToProps)(AdminFileStatusesListItem)));
